import { Link } from "react-router-dom";
import PageLayout from "@/components/aoria/PageLayout";
import PageHeader from "@/components/aoria/PageHeader";
import Seo from "@/components/aoria/Seo";
import FAQ from "@/components/aoria/FAQ";

export default function FaqPage() {
    return (
        <PageLayout testid="faq-page">
            <Seo
                title="FAQ · Six questions sur l'IA, l'apprentissage et la triche · Aoria"
                description="Questions fréquentes sur l'usage raisonné de l'intelligence artificielle : triche, dépendance, hallucinations, confidentialité, place dans l'enseignement. Des réponses équilibrées, sans angélisme ni rejet de principe."
                path="/faq"
            />
            <PageHeader
                testid="faq"
                eyebrow="FAQ"
                title="Six questions"
                italic="qu'il faut poser à voix haute"
                lead="Triche, dépendance, hallucinations, confidentialité, place dans l'enseignement : voici nos réponses, formulées sans angélisme et sans rejet de principe. Le but est de nourrir un débat lucide."
                backdrop="whisper"
            />

            <FAQ />

            {/* « Ce que nous défendons », prolongement éditorial de la FAQ */}
            <section
                data-testid="faq-principes-section"
                className="py-20 md:py-28 border-t border-[#E0E1DD] bg-[#F4F5F7]"
            >
                <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-20">
                    <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 mb-12">
                        <div className="lg:col-span-3">
                            <div className="reveal flex items-center gap-4">
                                <span
                                    aria-hidden="true"
                                    className="inline-block h-px w-9 bg-[#0D1B2A]/40"
                                />
                                <span className="eyebrow">Ce que nous défendons</span>
                            </div>
                        </div>
                        <div className="lg:col-span-9 max-w-3xl">
                            <h2 className="reveal delay-1 h2 text-3xl md:text-4xl text-[#0D1B2A] leading-tight">
                                Quatre principes{" "}
                                <span className="italic text-[#415A77]">
                                    qui guident notre lecture du sujet
                                </span>
                                .
                            </h2>
                        </div>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-7">
                        {[
                            {
                                n: "01",
                                title: "L'IA est un outil, pas une finalité",
                                body: "Les outils d'intelligence artificielle ne sont jugés ni « bons » ni « mauvais » en soi : c'est l'usage, le contexte et la lucidité avec laquelle on les emploie qui font la différence.",
                            },
                            {
                                n: "02",
                                title: "L'accessibilité cognitive concerne potentiellement chacun",
                                body: "À un moment ou un autre de sa vie (fatigue, vieillissement, période difficile, sujet inconnu), chaque personne fait face à des obstacles cognitifs. Le sujet n'est pas marginal.",
                            },
                            {
                                n: "03",
                                title: "L'autonomie compte plus que l'assistance permanente",
                                body: "Un outil est utile s'il élargit l'autonomie de celles et ceux qui s'en servent. S'il les enferme dans une dépendance, l'usage doit être réinterrogé.",
                            },
                            {
                                n: "04",
                                title: "L'équité suppose parfois des moyens différents",
                                body: "Donner exactement la même chose à tous n'est pas équitable. L'équité, c'est donner à chacun ce qui lui permet réellement de participer pleinement.",
                            },
                        ].map((p, i) => (
                            <article
                                key={p.n}
                                data-testid={`faq-principe-${i}`}
                                className="card-aoria"
                            >
                                <div className="flex items-center justify-between mb-6">
                                    <span className="editorial-num text-sm">
                                        {p.n}
                                    </span>
                                    <span className="eyebrow text-[#778DA9]">
                                        Principe
                                    </span>
                                </div>
                                <h3 className="h3 text-lg md:text-xl text-[#0D1B2A] leading-snug">
                                    {p.title}
                                </h3>
                                <p className="mt-4 text-[#5C6B7D] text-sm leading-relaxed flex-1">
                                    {p.body}
                                </p>
                            </article>
                        ))}
                    </div>
                </div>
            </section>

            <div className="max-w-3xl mx-auto px-6 md:px-12 lg:px-20 pt-16 md:pt-20 pb-24 md:pb-32 text-center">
                <p className="text-[#5C6B7D] leading-relaxed">
                    Vous avez une question qui ne figure pas ici ?{" "}
                    <Link
                        to="/contact"
                        data-testid="faq-cta-contact"
                        className="link-underline text-[#0D1B2A]"
                    >
                        Écrivez-nous
                    </Link>
                    .
                </p>
            </div>
        </PageLayout>
    );
}
